import { APP_CONSTANTS } from 'src/app/constants/constants';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
    selector: 'app-trusted-contact-operations',
    templateUrl: './trusted-contact-operations.component.html',
    styleUrls: ['./trusted-contact-operations.component.scss']
})
export class TrustedContactOperationsComponent implements OnInit {
    APP_CONSTANTS = APP_CONSTANTS;

    @Input() trustedcontact_data: any;
    @Input() client_data: any;
    @Input() operation_type: any;

    @Output() trustedContactOperationsClosed = new EventEmitter<any>();
    @Output() trustedContactsUpdated = new EventEmitter<any>();

    user_details: any;

    constructor(
        public commonService: CommonService,
        private storageService: StorageService,
        private dialog: MatDialog,
        private datePipe: DatePipe,
    ) { }

    ngOnInit(): void {
        this.user_details = this.storageService.get("user_details");

        this.getGenders();
        this.getRelationships();

        if (this.operation_type == "Add") {
            this.trustedcontact_data = this.ideal_trustedcontact_data;
        }

        if (this.operation_type == "Add" || this.operation_type == "Edit") {
            setTimeout(() => {
                this.openTrustedContactOperationModal();
            }, 200);
        } else if (this.operation_type == "Delete") {
            setTimeout(() => {
                this.openDeleteTrustedContact();
            }, 200);
        }


    }

    genders_list: any = [];
    getGenders() {
        this.commonService.getData('/gender?no_page=true/').subscribe(
        (res: any) => {
            this.genders_list = res;
        },
        (err) => {
            this.commonService.showToast('error', err.error);
        },
        );
    }


    relationships_list: any = [];
    getRelationships() {
        this.commonService.getData('/relationship?no_page=true/').subscribe(
        (res: any) => {
            this.relationships_list = res;
        },
        (err) => {
            this.commonService.showToast('error', err.error);
        },
        );
    }


    ideal_trustedcontact_data: any = {
        first_name: "",
        last_name: "",
        email: "",
        birth_date: "",
        gender: "",
        gender_name: "",
        relationship_type: "",
        relationship_type_name: "",
        telephone_number: "",
    };
    trustedcontact_data_errors: any = {
        first_name: false,
        last_name: false,
        email: false,
        birth_date: false,
        gender: false,
        gender_name: false,
        relationship_type: false,
        relationship_type_name: false,
        telephone_number: false,
    };

    resetTrustedContactData() {
        this.ideal_trustedcontact_data = {
            first_name: "",
            last_name: "",
            email: "",
            birth_date: "",
            gender: "",
            gender_name: "",
            relationship_type: "",
            relationship_type_name: "",
            telephone_number: "",
        };
        this.trustedcontact_data_errors = {
            first_name: false,
            last_name: false,
            email: false,
            birth_date: false,
            gender: false,
            gender_name: false,
            relationship_type: false,
            relationship_type_name: false,
            telephone_number: false,
        };
    }

    @ViewChild('trustedcontactOperationModal') trustedcontactOperationModal: TemplateRef<any>;
    private trustedcontactOperationModalRef: MatDialogRef<TemplateRef<any>>;
    openTrustedContactOperationModal() {

        if (this.operation_type == "Edit") {
            this.trustedcontact_data.birth_date = this.datePipe.transform(this.trustedcontact_data.birth_date, 'MM-dd-yyyy');
        }

        this.trustedcontactOperationModalRef = this.dialog.open(this.trustedcontactOperationModal, { disableClose: true });
        this.trustedcontactOperationModalRef.afterClosed().subscribe((result) => {
            this.closeTrustedContactOperationModal();
        });
    }

    closeTrustedContactOperationModal() {
        this.resetTrustedContactData();
        this.trustedcontactOperationModalRef.close();
        this.trustedContactOperationsClosed.emit("Closed");
    }

    validEmail(email) {
        if (
            email != '' &&
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
        ) {
            return true;
        } else {
            return false;
        }
    }

    validatePhoneNumber(number) {
        const regex = /^[\+][(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/gm;
        if (number == null || number == '') {
            return false;
        }

        if (regex.test(number) == true) {
            return true;
        } else {
            return false;
        }
    }

    saveTrustedContactData() {
        if (
            this.trustedcontact_data.first_name != "" &&
            this.trustedcontact_data.first_name != null
        ) {
            this.trustedcontact_data_errors.first_name = false;
        } else {
            this.trustedcontact_data_errors.first_name = true;
        }

        if (
            this.trustedcontact_data.last_name != "" &&
            this.trustedcontact_data.last_name != null
        ) {
            this.trustedcontact_data_errors.last_name = false;
        } else {
            this.trustedcontact_data_errors.last_name = true;
        }

        // if (
        //     this.trustedcontact_data.email != "" &&
        //     this.trustedcontact_data.email != null &&
        //     this.validEmail(this.trustedcontact_data.email)
        // ) {
        //     this.trustedcontact_data_errors.email = false;
        // } else {
        //     this.trustedcontact_data_errors.email = true;
        // }

        // if (
        //     this.trustedcontact_data.birth_date != "" &&
        //     this.trustedcontact_data.birth_date != null
        // ) {
        //     this.trustedcontact_data_errors.birth_date = false;
        // } else {
        //     this.trustedcontact_data_errors.birth_date = true;
        // }

        // if (
        //     this.trustedcontact_data.gender != "" &&
        //     this.trustedcontact_data.gender != null
        // ) {
        //     this.trustedcontact_data_errors.gender = false;
        // } else {
        //     this.trustedcontact_data_errors.gender = true;
        // }

        // if (
        //     this.trustedcontact_data.relationship_type != "" &&
        //     this.trustedcontact_data.relationship_type != null
        // ) {
        //     this.trustedcontact_data_errors.relationship_type = false;
        // } else {
        //     this.trustedcontact_data_errors.relationship_type = true;
        // }

        if (
            this.trustedcontact_data.telephone_number != "" &&
            this.trustedcontact_data.telephone_number != null
        ) {
            if (
                // this.validatePhoneNumber(this.trustedcontact_data.telephone_number) &&
                this.trustedcontact_data.telephone_number.length >= APP_CONSTANTS.PHONE_NUMBER_LENGTH
              ){
                this.trustedcontact_data_errors.telephone_number = false;
            }else{
                this.trustedcontact_data_errors.telephone_number = false;
            }
        } else {
            this.trustedcontact_data_errors.telephone_number = true;
        }

        if (
            this.trustedcontact_data_errors.first_name == false &&
            this.trustedcontact_data_errors.last_name == false &&
            // this.trustedcontact_data_errors.is_primary == false &&
            // this.trustedcontact_data_errors.email == false &&
            // this.trustedcontact_data_errors.birth_date == false &&
            // this.trustedcontact_data_errors.gender == false &&
            // this.trustedcontact_data_errors.relationship_type == false &&
            this.trustedcontact_data_errors.telephone_number == false
        ) {
            let payload: any = this.trustedcontact_data;

            payload.business_area = this.user_details.role.business_area[0];

            if(this.trustedcontact_data.birth_date != "" && this.trustedcontact_data.birth_date != null) {
                payload.birth_date = moment(payload.birth_date).format();
            } else {
                delete payload['birth_date'];
            }


            if(this.trustedcontact_data_errors.birth_date == true) {
                delete payload['birth_date'];
            }

            if(this.trustedcontact_data_errors.percentage_allocation == true){
                payload.percentage_allocation = 0
            }

            payload.client = this.client_data.id;

            if (this.operation_type == 'Add') {
                this.commonService.postData('/trustedcontact', payload).subscribe(
                    (res: any) => {
                        // this.getClientsData();
                        this.trustedContactsUpdated.emit("Added");
                        this.commonService.showToast('success', 'Trusted Contact Added Successfully.');
                        // this.closeTrustedContactOperationModal();
                        this.resetTrustedContactData();
                        this.trustedcontactOperationModalRef.close();
                    },
                    (err) => {
                        this.commonService.showToast('error', err.error);
                    },
                );
            } else if (this.operation_type == 'Edit') {
                this.commonService.patch('/trustedcontact/' + payload.id, payload).subscribe(
                    (res: any) => {
                        // this.getClientsData();
                        this.trustedContactsUpdated.emit("Updated");
                        this.commonService.showToast('success', 'Trusted Contact Updated Successfully.');
                        // this.closeTrustedContactOperationModal();
                        this.resetTrustedContactData();
                        this.trustedcontactOperationModalRef.close();
                    },
                    (err) => {
                        this.commonService.showToast('error', err.error);
                    },
                );
            }
        }
    }

    @ViewChild('trustedcontactDeleteModal') trustedcontactDeleteModal: TemplateRef<any>;
    private trustedcontactDeleteModalRef: MatDialogRef<TemplateRef<any>>;

    openDeleteTrustedContact() {
        //   this.trustedcontact_data = JSON.parse(JSON.stringify(data));
        this.trustedcontactDeleteModalRef = this.dialog.open(this.trustedcontactDeleteModal, { disableClose: true });
        this.trustedcontactDeleteModalRef.afterClosed().subscribe((result) => {
            this.closeTrustedContactDeleteModal();
        });
    }

    closeTrustedContactDeleteModal() {
        this.resetTrustedContactData();
        this.trustedcontactDeleteModalRef.close();
        this.trustedContactOperationsClosed.emit("Closed");
    }

    deleteTrustedContactData() {
        const payload = [this.trustedcontact_data.id];
        this.commonService.delete('/trustedcontact/destroy?ids=' + payload).subscribe(
            (res: any) => {
                this.trustedContactsUpdated.emit("Deleted");
                this.commonService.showToast('success', 'Trusted Contact Deleted Successfully.');

                //   const index = this.table_data[this.show_trustedcontact].trusted_contact.findIndex(
                //     (x) => x.id == this.trustedcontact_data.id,
                //   );
                //   this.table_data[this.show_trustedcontact].trusted_contact.splice(index, 1);

                // this.closeTrustedContactDeleteModal();
                this.resetTrustedContactData();
                this.trustedcontactDeleteModalRef.close();
            },
            (err) => {
                this.commonService.showToast('error', err.error);
            },
        );
    }

    numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

}
